const TStrings = {
    REPORTS_TITLE: 'Reports',
    CREATE_REPORT_BUTTON: 'Add Report',
    NO_REPORTS_MSG: 'You have no reports (right now!)',
    EDIT_REPORT_BUTTON_TITLE: 'Edit Name',
    DUPLICATE_REPORT_BUTTON_TITLE: 'Duplicate',
    DUPLICATE_REPORT_BUTTON_TITLE_LOADING: 'Duplicating...',
    DELETE_REPORT_BUTTON_TITLE: 'Delete Report',
    DELETE_REPORT_BUTTON_TITLE_LOADING: 'Deleting...',
    CREATE_REPORT_TITLE: 'Create Report',
    EDIT_REPORT_TITLE: 'Edit Report',
    CREATE_BLANK_TEMPLATE_TITLE: 'Start from scratch',
    CREATE_LAST_MONTH_BOOKINGS_TEMPLATE_TITLE: 'Last month bookings',
    CREATE_ALL_CLIENTS_TEMPLATE_TITLE: 'All Clients',
    CREATE_ALL_CLASSES_TEMPLATE_TITLE: 'All Classes',
    CREATE_REVENUE_TITLE: 'Revenue',
    CREATE_REVENUE_PER_TYPE_TITLE: 'Revenue per event type',
    EDIT_TEMPLATE_BUTTON: 'Edit',
    REPORT_TEMPLATE_TITLE: 'REPORT TEMPLATE',
    REPORT_NAME_TITLE: 'REPORT NAME',
    REPORT_ON_TITLE: 'REPORT ON',
    CREATE_REPORT_TEMPLATE_BUTTON: 'Create Report',
    SAVING_REPORT_TEMPLATE_BUTTON: 'Saving...',
    EDIT_REPORT_TEMPLATE_BUTTON: 'Save',
    CANCEL_BUTTON: 'Cancel',
    DELETE_BUTTON: 'Delete',
    REPORT_PLACEHOLDER: 'Report Name...',
    NO_REPORT_NAME_ERROR: 'Please provide a name for the report',
};

export default TStrings;
